module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMjkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI2Ljk1MS41NjJhMS40MTMgMS40MTMgMCAwIDAtMi4wMTQgMCAxLjQxMiAxLjQxMiAwIDAgMCAwIDEuOTg4bDEwLjIyIDEwLjE3NUgxLjQzMUMuNjQ1IDEyLjcyNSAwIDEzLjM1IDAgMTQuMTI4YzAgLjc4NC42NDUgMS40MjUgMS40MzIgMS40MjVoMzMuNzI0bC0xMC4yMiAxMC4xNThjLS41NDUuNTYxLS41NDUgMS40NyAwIDIuMDA4YTEuNDE2IDEuNDE2IDAgMCAwIDIuMDE1IDBsMTIuNjQtMTIuNTg1YTEuNDEyIDEuNDEyIDAgMCAwIDAtMS45ODhMMjYuOTUuNTYyeiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/icon/arrow.svg
// module id = v8Rn
// module chunks = 0